import { z } from 'zod';

export const setAutopilotEnabledV1RequestSchema = z.object({
  enabled: z.boolean(),
});

export type ISetAutopilotEnabledV1Request = z.infer<typeof setAutopilotEnabledV1RequestSchema>;
